var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invalid-box"},[_c('div',{staticClass:"title text-error text-bold"},[_vm._v("\n\t\t"+_vm._s(_vm.$t('error.invalid.checklist_type.title'))+"\n\t")]),_vm._v(" "),_c('div',{staticClass:"description"},[_vm._v("\n\t\t"+_vm._s(_vm.$t('error.invalid.checklist_type.message',{ type: _vm.checklistType }))+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }